import React, { useState, useEffect  } from "react";

import { Formik, Field, Form } from "formik";
import { fetchAPI } from "@/utility/NetworkUtils";

import { Button, Stack, Chip, FormControlLabel } from "@mui/material";
import Select from 'react-select'
import { renderTextField } from "@/shared/FormUtils";
const UserForm = ({editingUser = {},user, onClose, onSave}) => {
  const { selectValue } = user
  const [ renters, setRenters ] = useState([]);

  const fetchRenters = async () => {
    fetchAPI(`/webapi/renters`, (json)=> {
      if (!json.errors) {
        setRenters(json.renters)
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  }

  useEffect(() => {
    fetchRenters();
  },[]);

  const renderRenters = (formikProps) => {
    return renters.filter(x=>formikProps.values.user.renter_ids.includes(x.id)).map(renter => (
      <Chip 
        size="small"
        label={renter.name}
        color="clientblue"
        className="mr-1"
        onDelete={()=> removeRenter(formikProps, renter.id)}
      />
    ))
  }

  const removeRenter = (formikProps, renterId) => {
    formikProps.setFieldValue("user.renter_ids", formikProps.values.user.renter_ids.filter(id => id != renterId))
  }

  const [ submitting, setSubmitting ] = useState(false);
  const [ error, setError ] = useState(null);

  const attemptSave = (values, formikProps) => {
    if(submitting) return;
    setError(null);
    let parsedValues = values
    if(editingUser?.id) {
      //Remove password key from hahs
      delete parsedValues.user.password
      delete parsedValues.user.password_confirmation
    }
    setSubmitting(true);
    fetchAPI(editingUser?.id ? `/webapi/users/${editingUser.id}` : `/webapi/users/`, (json)=> {
      setSubmitting(false);
      formikProps.setSubmitting(false);
      if(!json.error) {
        onSave(json.user)
      }else {
        setError(json.error)
      }
    }, {
      method: editingUser?.id ? "PATCH" : "POST",
      body: values
    })
  }

  return (
    <Formik
      initialValues={{
        user: {
          first_name: editingUser?.first_name,
          last_name: editingUser?.last_name,
          email: editingUser?.email,
          password: "",
          password_confirmation: "",
          role: editingUser?.role || "client",
          renter_ids: (editingUser?.renters||[]).map(renter => renter.id)
        }
      }}
      onSubmit={attemptSave}
    >
      {(formikProps) => (
        
      <Form className="font-['Roboto']">
        <Stack spacing={2}>
          <div className="text-emerald-900 text-xl font-medium font-['Roboto']">
            {editingUser?.id ? `Edit ${editingUser.first_name} ${editingUser.last_name}` : "Add New User"}
          </div>
          <Stack direction="row" spacing={2} justifyContent="space-between">
            {renderTextField("First Name", `user[first_name]`)}
            {renderTextField("Last Name", `user[last_name]`)}
          </Stack>
          {renderTextField("Email", `user[email]`)}
          {!editingUser?.id && (
            <>
              {renderTextField("Password", `user[password]`, {type: "password"})}
              {renderTextField("Confirm Password", `user[password_confirmation]`, {type: "password"})}
            </>
          )}
          <div className="font-black text-[16px] text-black text-base font-normal font-['Roboto'] leading-6 tracking-tight">
            Select the inventory you would like the user to have access to. You can select more than one.
          </div>
          <div className={"sg-mgmt-form-input-container"}>
            <label>
              Inventories
            </label>
            <Select
              classNamePrefix="sg-mgmt-form-input-select"
              value={{value: "", label: "Select..."}}
              menuPortalTarget={document.body}
              onChange={(e)=> formikProps.setFieldValue("user.renter_ids", formikProps.values.user.renter_ids.concat([e.value]))}
              options={renters.map(renter => ({value: renter.id, label: renter.name})).filter(renter => !formikProps.values.user.renter_ids.includes(renter.value))}
            />
          </div>
    
          <Stack direction="row" spacing={1}>
            {renderRenters(formikProps)}
          </Stack>
          {error && <div className="text-bold text-red-500">{error}</div>}
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              onClick={onClose}
              variant="contained"
              color="cancel"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="green"
              disabled={submitting || !formikProps.dirty}
            >
              {editingUser?.id ? "Save" : "Add New User"}
            </Button>
          </Stack>
        </Stack>
      </Form>
      )}
    </Formik>
  )
}
      
export default UserForm